module.exports = __webpack_public_path__ + "img/Slice8-min.9a77c9ed.png";